import React from 'react';
import { RANGE_PRESETS, todayInput, formatRangeLabel } from './range';

// The one filter row for the whole dashboard: presets first (nobody fights a
// calendar grid for "last 30 days"), custom range tucked behind them.
const DateRangeFilter = ({ range, onChange, resolvedStart, resolvedEnd, busy }) => {
  const isCustom = range.preset === 'custom';
  const today = todayInput();

  const selectPreset = (id) => onChange({ ...range, preset: id });

  const openCustom = () =>
    onChange({
      preset: 'custom',
      start: range.start || resolvedStart || '',
      end: range.end || resolvedEnd || today,
    });

  // The hover background is spelled out on purpose: App.css carries a global
  // `button:hover { background-color: #0056b3 }` whose pseudo-class outranks a
  // single Tailwind `bg-*` class, so any button without one turns blue on hover.
  const tabClass = (active) =>
    `px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-200 border ${
      active
        ? 'bg-purple-500/20 hover:bg-purple-500/30 text-purple-200 border-purple-400/40'
        : 'bg-gray-800/60 hover:bg-gray-700/60 text-gray-400 border-gray-700 hover:text-white hover:border-gray-500'
    }`;

  return (
    <div className="flex flex-wrap items-center gap-3">
      <div className="flex flex-wrap items-center gap-2">
        {RANGE_PRESETS.map((preset) => (
          <button
            key={preset.id}
            type="button"
            onClick={() => selectPreset(preset.id)}
            aria-pressed={!isCustom && range.preset === preset.id}
            className={tabClass(!isCustom && range.preset === preset.id)}
          >
            {preset.label}
          </button>
        ))}
        <button
          type="button"
          onClick={openCustom}
          aria-pressed={isCustom}
          className={tabClass(isCustom)}
        >
          Custom
        </button>
      </div>

      {isCustom && (
        <div className="flex flex-wrap items-center gap-2 sm:pl-3 sm:border-l sm:border-gray-700">
          <label className="sr-only" htmlFor="range-start">Start date</label>
          <input
            id="range-start"
            type="date"
            value={range.start}
            max={range.end || today}
            onChange={(e) => onChange({ ...range, preset: 'custom', start: e.target.value })}
            className="bg-gray-800/60 border border-gray-700 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent [color-scheme:dark]"
          />
          <span className="text-gray-500 text-sm">to</span>
          <label className="sr-only" htmlFor="range-end">End date</label>
          <input
            id="range-end"
            type="date"
            value={range.end}
            min={range.start || undefined}
            max={today}
            onChange={(e) => onChange({ ...range, preset: 'custom', end: e.target.value })}
            className="bg-gray-800/60 border border-gray-700 rounded-lg px-3 py-2 text-sm text-white focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent [color-scheme:dark]"
          />
        </div>
      )}

      <span className="text-sm text-gray-500 sm:ml-auto" aria-live="polite">
        {busy ? 'Updating…' : formatRangeLabel(resolvedStart, resolvedEnd)}
      </span>
    </div>
  );
};

export default DateRangeFilter;
